
import Table from './Table';
import ActivityCard from '../../../../Core/Activity/ActivityCard';

const Tab2 = ({ setSelectedCompanyAccounts, apidata, isyca, setyca, companyAccounts,addressId }) => {
    return (
    <div>
            <div
            className="row "
            style={{ border: "1px solid rgba(50, 50, 50, 0.35)", borderRadius: "5px" }}
        >
            <div className="col-12">
                <p className="boxLabel m-0">Reference</p>
                <div>
                    <div className='mx-1 mb-3' style={{ fontSize: '10px', color: '#00000099' }}>
                        <input
                            type="checkbox"
                            id="defaultCheck"
                            style={{ width: '10px', height: '10px' }}
                            checked={isyca === 1}
                            onChange={(e) => setyca(e.target.checked ? 1 : 0)}
                        />
                        <label htmlFor="defaultCheck" style={{ marginLeft: '0.5rem' }}>Is Your Company Address</label>
                    </div>
                </div>
                <Table
                    setSelectedCompanyAccounts={setSelectedCompanyAccounts} apidata={apidata} companyAccounts={companyAccounts}
                />
            </div>
        </div>
             <div className="mt-3">
                <ActivityCard doctype="Address" docname={addressId} />
            </div>

    </div>
    )
}

export default Tab2